module.exports = __webpack_public_path__ + "img/humanrobat-1.4af13cb5.png";